module.exports = __webpack_public_path__ + "img/image_001.202eccb9.png";